/**
 * Checks if a string contains special characters
 * @param value - The string to check
 * @param exceptions - Optional array of characters to exclude from special character check
 * @returns true if the string contains special characters (excluding exceptions), false otherwise
 */
export const hasSpecialCharacters = (value: string, exceptions: string[] = []): boolean => {
  if (!value || typeof value !== 'string') {
    return false
  }

  const specialCharRegex = /[^a-zA-Z0-9]/g

  const specialChars = value.match(specialCharRegex) || []

  const filteredSpecialChars = specialChars.filter(char => !exceptions.includes(char))

  return filteredSpecialChars.length > 0
}
